import { render, staticRenderFns } from "./TestItemDetail.vue?vue&type=template&id=3cf3783e&scoped=true"
import script from "./TestItemDetail.vue?vue&type=script&lang=js"
export * from "./TestItemDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf3783e",
  null
  
)

export default component.exports